import styled from 'styled-components';
import { CtaButton } from '../common-components/CtaButton';
import { Background } from '../common-components/Background';
import { HtmlZone } from '../common-components/HtmlZone';

export const NextCtaButton = styled(CtaButton)`
  height: 6vh;
  padding: 1vh 1vw;
  position: absolute;
  bottom: 4vh;
  left: 30vw;
  right: 30vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 5vw;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3);
`;
NextCtaButton.displayName = 'NextCtaButton';

export const NextBackground = styled(Background)`
  height: 37vh;
  bottom: 3vh;
  margin: 5vw;
  width: 90vw;
`;
NextBackground.displayName = 'NextBackground';

export const NextHtmlZone = styled(HtmlZone)`
  align-content: left;
  justify-content: left;
  width: 65vw;
  height: 20vh;
`;
NextHtmlZone.displayName = 'NextHtmlZone';
